// extracted by mini-css-extract-plugin
export default {"root":"Description_root__fGuSv","label":"Description_label__452wr","body":"Description_body__DHu0m"};